// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ekEJm","page-content-area":"styles_page-content-area__0DPuT"};